import ProductsCard from "./ProductsCard";

const productsData = [
  {
    name: "Raadco",
    image: "/Products/Raadco.svg",
    description:
      "Raadco builds intelligent AI systems that help businesses grow smarter, faster, and more efficient.From concept to launch, we partner with you to deliver real-world results through smart software.Collaborative, innovative, and reliable—we shape the future of AI, together.",
    backgroundColor:
      "bg-[linear-gradient(80.76deg,_#433CAE_4.19%,_#8982F4_132.19%)]",
    link: "https://raadco.com.au/",
  },
  {
    name: "Nibex",
    image: "/Products/Nibex.svg",
    description:
      "Nibex is a creative design agency partnering with AI innovators to craft seamless digital experiences.We specialize in intuitive UI/UX design, blending creativity with insight to engage users and elevate brands.Consultative, modern, and approachable—we turn bold ideas into powerful products.",
    backgroundColor:
      "bg-[linear-gradient(80.76deg,_#F15A25_4.19%,_#FBCBAD_132.19%)]",
    link: "https://nibex.io",
  },

  {
    name: "Remocapp",
    image: "/Products/Remocapp.svg",
    description:
      "Remocapp lets you create a real-time motion capture studio with ease.Capture body and facial movements instantly—no markers or suits needed.Stream personalized avatars live with speed, accuracy, and simplicity.",
    backgroundColor:
      "bg-[linear-gradient(80.76deg,_#0C0E0E_4.19%,_#757777_132.19%)]",
    link: "https://remocapp.com",
  },
  {
    name: "IA Motion",
    image: "/Products/IAMotion.svg",
    description:
      "IA Motion is an AI-powered tool that assesses workplace ergonomics using just a smartphone camera.By automating REBA-based posture analysis, it delivers instant safety reports with clear visuals.Fast, simple, and expert-backed—it makes health and safety assessments easier for everyone.",
    backgroundColor:
      "bg-[linear-gradient(80.76deg,_#218FC4_4.19%,_#49B7EC_132.19%)]",
    link: "http://intro.iamotion.ai/",
  },
  {
    name: "Refit",
    image: "/Products/Refit.svg",
    description:
      "ReFit transforms your fitness journey with real-time motion capture and personalized training.Track your movements with precision, improve technique, and stay motivated with expert-guided programs.Smarter workouts, safer progress, and real results—powered by ReFit.",
    backgroundColor:
      "bg-[linear-gradient(80.76deg,_#ABC80E_4.19%,_#EBEBC2_132.19%)]",
    link: "https://refit.raadco.com.au",
  },
  {
    name: "SydaFarm",
    image: "/Products/SydaFarm.svg",
    description:
      "SydaFarm AI combines AI, IoT, and real-time analytics to revolutionize modern farming.Our smart solutions help boost crop yields, reduce waste, and optimize every aspect of farm management.Grow smarter with data-driven insights and powerful agricultural automation.",
    backgroundColor:
      "bg-[linear-gradient(80.76deg,_#059669_4.19%,_#4BDCAF_132.19%)]",
    link: "https://syda-farm.com/",
  },
];

const ProductsPage = () => {
  return (
    <div
      className=" py-[100px] max-w-[1604px] lg:px-[40px] px-4 mx-auto bg-sharps bg-cover bg-center"
      style={{
        fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
      }}
    >
      <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 gap-y-6 justify-center">
        {productsData.map((product, key) => (
          <ProductsCard
            {...product}
            key={key}
            color={key % 2 === 0 ? "dark" : "light"}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductsPage;
